'use client';
import { styled, css } from '@mui/material/styles';
export const StackedNavList = styled('ul')(({ theme }) => css `
    display: flex;
    flex-direction: column;
    gap: ${theme.tokens.FuelSpacing1};

    margin: 0;
    padding: ${theme.tokens.FuelSpacing2} ${theme.tokens.FuelSpacing1};

    .NavItem-root {
        display: block;
    }
`);
